import useGetItem from "./hooks/useGetItem";
import { useParams } from "react-router-dom";
import useDelete from "./hooks/useDelete";
import useUpdate from "./hooks/useUpdate";
import { GenericMethods } from "layouts/aplicacoes/GenericMethods";
import { SchemaData } from "./hooks/types";
import { UpdateGql } from "./queries/update";
import { UpdateProps } from "./types";

function Update(props: UpdateProps) {
  const id = Number(useParams()?.id);

  if (!id) return null;

  return (
    <GenericMethods.Update<SchemaData, UpdateGql>
      siteId={props.idSite}
      sitePath={props.path}
      redirectPath={`${props.path}/popups`}
      useDelete={useDelete}
      useGetItem={useGetItem}
      useUpdate={useUpdate}
      queryParam={id}
    />
  );
}

export default Update;
